const blogPosts = [
  {
    id: 1,
    title: 'Understanding React Hooks',
    date: '2023-09-10',
    description: 'An in-depth look into React Hooks and their usage.',
    images: ['/images/react-hooks-1.png', '/images/react-hooks-2.png'], // Multiple images
    content: 'Details about Event One...',
  },
  {
    id: 2,
    title: 'JavaScript ES6 Features',
    date: '2023-09-15',
    description: 'Exploring the new features introduced in ES6.',
    images: ['/images/es6-features-1.png'], // Single image in array
    content: 'Insights on Event Two...',
  },
  // Add more blog posts as needed
];

export default blogPosts;